import axios from 'axios';



export const smallScreen = 460;
export const mediumScreen = 820;
export var extParams = []

//Global functions that can be used in diffrent projects
//treat the response from api axios
export function axiosResponse(response, f = () => { }) {
  if (response.response) {
    // The request was made and the server responded with a status code
    // that falls out of the range of 2xx
    //console.log(response.response.data);
    //console.log(response.response.status);
    //console.log(response.response.headers);
    /* if(response.response.status>400){
       localStorage.clear();
     }
     window.location=("/"); */
  } else if (response.request) {
    // The request was made but no response was received
    // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
    // http.ClientRequest in node.js
    // console.log(response);
    // console.log(response.request);
    // console.log(response.message);
    //changer le lien 
    if (response.request.status < 100) {
      alert("Une erreur s'est produite");
      // if(localStorage.getItem("netError")!==response.message||!window.location.pathname.split("/")[1].includes("error")){window.location=("/error?message="+response.message); }}
    }
    //else {if(localStorage.getItem("netError")!=="undefined") window.location=("/") }
    //localStorage.setItem("netError",response.message);
  } else {
    // Something happened in setting up the request that triggered an Error
    //console.log('Error', response.message);
  }
  if (response.data) {
    if (response.data.err == null) {
      f();
    } else {
      if (localStorage.length !== 0) {
        if (response.data.err === "-1") {
          alert("Votre session est expiré");
          localStorage.clear(); //we have saved some data in local storage on login so it must be cleared when the session is expired
          window.location = ("/"); // to return to login page 
        } else {
          alert(response.data.err);
        }
      }
    }
  }
}

//get headers 
export function getHeader() {
  const param = JSON.parse(localStorage.getItem("param"));
  const headers = {
    'content-type': 'application/json, multipart/form-data',
    'session': localStorage.getItem('token'),
    'appID': param.appID,
  }
  return headers;
}
//get headers in case of FormData
export function getHeader2() {
  const param = JSON.parse(localStorage.getItem("param"));
  const headers = {
    'Content-Type': 'multipart/form-data',
    'session': localStorage.getItem('token'),
    'appID': param.appID,
  }
  return headers;
}
// manage the ajax's errors in datatables 
export function errorMan(data) {
  if (data.err != null && data.err !== undefined) {
    if (data.err === '-1') {
      alert('votre session est expiré ');
      localStorage.setItem('isLoged', false);
      window.location = ("/");
    } else alert(data.err);
  }
}
//test if an object is empty 
export function isEmpty(obj) {
  for (var key in obj) {
    if (obj.hasOwnProperty(key))
      return false;
  }
  return true;
}
//get response from add service
export function axiosAdd(api, data) {
  const param = JSON.parse(localStorage.getItem("param"));
  const response = axios({
    method: 'POST',
    url: param.urlService + api + '?do=add',
    headers: getHeader(),
    data: JSON.stringify(data)
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}
//get service
export function axiosGetAction(api, service) {
  const param = JSON.parse(localStorage.getItem("param"));
  const response = axios({
    method: 'GET',
    url: param.urlService + api + '?do=' + service,
    headers: getHeader(),
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}

// get avec params
export function axiosGetAction2(api, service, params = {}) {
  const param = JSON.parse(localStorage.getItem("param"));
  const response = axios({
    method: 'GET',
    url: param.urlService + api + '?do=' + service,
    params: params,
    headers: getHeader(),
  }).catch(function (error) {
    error["data"] = "";
    return error;
  });
  return response;
}

export function axiosGetActionWithParams(api, service, params = {}) {
  const param = JSON.parse(localStorage.getItem("param"));

  const queryParams = new URLSearchParams();
  queryParams.append('do', service);
  Object.keys(params).forEach(key => {
    if (params[key] !== undefined && params[key] !== null) {
      queryParams.append(key, params[key]);
    }
  });

  const response = axios({
    method: 'GET',
    url: `${param.urlService}${api}?${queryParams.toString()}`,
    headers: getHeader(),
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}
//POST axios json
export function axiosPostAction(api, service, data) {
  const param = JSON.parse(localStorage.getItem("param"));
  var headers = getHeader2()
  if (!(data instanceof FormData)) {
    data = JSON.stringify(data)
    headers = getHeader()
  }
  const response = axios({
    method: 'POST',
    url: param.urlService + api + '?do=' + service,
    headers: headers,
    data: data,
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}

//get user infornations
export const getInfo = () => {
  const info = {
    name: localStorage.getItem('name'),
    session: localStorage.getItem('token'),
  }
  return info;
}

//POST axios json
export function axiosPostAction2(api, service, data, file) {
  const param = JSON.parse(localStorage.getItem("param"));
  if (!(data instanceof FormData))
    data = JSON.stringify(data)
  const response = axios({
    method: 'POST',
    url: param.urlService + api + '?do=' + service,
    headers: getHeader(),
    data: data + file,
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}
//POST axios formdata
export function axiosPostAction3(data) {
  const param = JSON.parse(localStorage.getItem("param"));
  const response = axios({
    method: 'POST',
    url: param.urlService + "http://localhost:80/backend/index.php",
    headers: getHeader(),
    data: data
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}
//POST axios
export function axiosFlagman(srv, id, att, val) {
  const param = JSON.parse(localStorage.getItem("param"));
  const response = axios({
    method: 'POST',
    url: param.urlService + 'flagman.php',
    headers: getHeader(),
    data: JSON.stringify({ srv: srv, id: id, att: att, val: val })
  }).catch(function (error) {
    error["data"] = ""
    return error
  })
  return response
}

// group by key function
export const groupBy = (array, key) => {
  return array.reduce((result, currentValue) => {
    (result[currentValue[key]] = result[currentValue[key]] || []).push(
      currentValue
    );
    return result;
  }, {});
};

// join two arrays of objects in a prop
export const merge = (a, b, prop) => {
  let merged = [];
  for (let i = 0; i < a.length; i++) {
    merged.push({
      ...a[i],
      ...(b.find((itmInner) => itmInner[prop] === a[i][prop]))
    }
    );
  }
  return merged
}

export const getDate = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();

  today = dd + '-' + mm + '-' + yyyy;
  return today
}
export const getTomorrow = () => {
  const date = new Date();
  date.setDate(date.getDate() + 1);
  date.setHours(0, 0, 0, 0);
  return date;
};

export const getDate2 = () => {
  var today = new Date();
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();

  today = yyyy + '-' + mm + '-' + dd;
  return today
}


export const formatDate = (today) => {
  if (!today) return null;
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();
  today = dd + '-' + mm + '-' + yyyy;
  return today
}

export const formatDate2 = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const day = String(date.getDate()).padStart(2, "0");
  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
};

export const formatDate1 = (today) => {
  var dd = String(today.getDate()).padStart(2, '0');
  var mm = String(today.getMonth() + 1).padStart(2, '0');
  var yyyy = today.getFullYear();

  today = yyyy + '-' + mm + '-' + dd;
  return today
}

export const dateReverse = (date) => {
  return date.split("-").reverse().join("-");
};
export const dateReverse2 = (dateTime) => {
  // Assurez-vous que la dateTime est bien au format attendu
  const [datePart, timePart] = dateTime.split(" ");
  const [year, month, day] = datePart.split("-");
  return `${day}-${month}-${year} ${timePart}`;
};
export const normalDate = (today) => {
  var dateParts = today.split("-");
  var dateObject = new Date(+dateParts[2], dateParts[1] - 1, +dateParts[0]);
  return dateObject
}
export function formatNumber(val) {
  return Intl.NumberFormat().format(val);
}
export function formatNumber2(val, dec) {
  return Intl.NumberFormat(undefined, {
    minimumFractionDigits: dec,
    maximumFractionDigits: dec,
  }).format(val);
}
//delete an item from an array of object by some attribute
export function removeItemsByAtt(arr, value, att) {
  var index = arr.map(x => {
    return x[att];
  }).indexOf(value);
  arr.splice(index, 1);
  return arr;
}
export function formatTime(time) {
  const [hours, minutes] = time.split(':');
  return `${hours}:${minutes}`;
};

// Fonction pour formater une date "DD-MM-YYYY" en "YYYY-MM-DD"
export function formDate2(inputDate) {
  const parts = inputDate.split('-');
  if (parts.length === 3) {
    return `${parts[2]}-${parts[1]}-${parts[0]}`; // Convertit en format YYYY-MM-DD
  } else {
    return inputDate; // Retourne la date d'entrée si le format est incorrect
  }
};

//return the index of an Object by a property value
export function getIndex(arr, val, att) {
  var index = arr.map(x => {
    return x[att];
  }).indexOf(val);
  return index;
}
//eliminer les espaces pour les chaines de caractere
export const DeleteSpace = (edt) => {
  do {
    var index = edt.indexOf("&nbsp;");
    if (index !== -1) {
      edt = edt.replace("&nbsp;", "");
      //edt=edt.replace(" ","")
    }
  } while (edt.indexOf("&nbsp;") !== -1);
  var text = edt.replace(/<[^>]*>/g, "")
  /*do{
    var ind = edt.indexOf("<div>");
    if(ind!==-1){ 
      edt=edt.replace("<div>"," ");
      edt=edt.replace("<br>"," ");
      edt=edt.replace("</div>"," ");
    }   
  } while (edt.indexOf("<div>")!==-1);*/
  /* do{
     var ind = edt.indexOf("</r>");
     if(ind!==-1){ 
       edt=edt.replace("</r>","");
     }   
   } while (edt.indexOf("/r")!==-1);*/
  return text
}
//remove unwanted spaces
export const DeleteSpace2 = (edt) => {
  edt = edt.replace(/&nbsp;/g, "");
  return edt.replace(/\s\s+/g, ' ').trim();
}

//get all keys
export const getKeys = (obj) => {
  const filters = []
  Object.keys(obj).map(key => {
    const f = {}
    f["att"] = key
    filters.push(f)
    return true;
  })
  return filters
}

//filter all (search multi creterias)
export const searchAll = (data, filters, search) => {
  const dat = data
  return (dat.filter((d) => filters.some(filterEl => ((d[filterEl.att].toString().toLowerCase()).includes(search.toLowerCase())))))
}

//get next element
export const navObj = (obj, currentKey, direction) => {
  return Object.keys(obj).indexOf(currentKey) + direction;
};

//get Time in seconds from hours and minutes
export const getClock = (date) => {
  var seconds = date.getSeconds();
  var minutes = date.getMinutes();
  var hour = date.getHours();
  return (hour + ':' + minutes + ':' + seconds);
};

//get x last days
export function LastXDay(x) {
  var d = new Date();
  d.setDate(d.getDate() - x);
  return d;
}

//check if phone number
export function phonenumber(inputtxt) {
  //var phoneno = /^\d{10}$/;
  var phoneno = '[0][5-7][4-7][0-9][0-9][0-9][0-9][0-9][0-9][0-9]';
  if (inputtxt.match(phoneno)) { return { response: true, message: "C'est le bon format" }; }
  else return { response: false, message: "Vous devez insérer le bon format" };
}

//Check if it is the same day
export const datesAreOnSameDay = (first, second) => {
  if (!first || !second) return false
  return (
    first.getFullYear() === second.getFullYear() &&
    first.getMonth() === second.getMonth() &&
    first.getDate() === second.getDate())
};

//Check if valide date
export const dateIsValide = (day) => {
  if (day === null || undefined) return false
  return (Object.prototype.toString.call(day) === "[object Date]" && !isNaN(day) && (datesAreOnSameDay(new Date(), day) || day.getTime() < new Date().getTime()))
};
//fetch update elemnt
export const updateElem = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined) elem.innerHTML = val;
}
//fetch update elemnumber
export const updateElemN = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined) elem.innerHTML = new Intl.NumberFormat().format(val);
}
//fetch update elem string
export const updateElemS = (id, val) => {
  var elem = document.getElementById(id);
  if (elem != null && elem !== undefined) elem.innerHTML = val;
}

//calculate unique items
export function countTableId(a, att) {
  // sets are, well, sets of unique items. no duplicates allowed
  let uniqueId = new Set();
  for (let elem of a) {
    uniqueId.add(elem[att]);
  }
  // the size of the set is the number of unique items we added
  return uniqueId.size;
}
//if empty string returns null
export function stringToNull(str) {
  if (str === '')
    return null;
  return str
}
//if empty string returns null
export function zeroToNull(val) {
  if (val === 0)
    return null;
  return val
}

//Covert Null to String for inputs
export function NullToString(value) {
  if (value === null || value === undefined) return "";
  return value;
};

//check if a number is odd
export function isOdd(num) { return num % 2; }

//sum of value in an array of objects 
export function sumArObj(arr, att) {
  const sum = arr.reduce((accumulator, object) => {
    return accumulator + object[att];
  }, 0);
  return sum;
}

//calcilate the item that are superior to something
export function supTo(arr, att, value) {
  let cpt = 0
  cpt = arr.reduce((accumulator, object) => {
    if (object[att] > value)
      return accumulator + 1;
    return accumulator + 0;
  }, 0);
  return cpt;
}
//calcilate the item that are inferior to something
export function infTo(arr, att, value) {
  let cpt = 0
  cpt = arr.reduce((accumulator, object) => {
    if (object[att] < value)
      return accumulator + 1;
    return accumulator + 0;
  }, 0);
  return cpt;
}

//format to 2 decimals to use it do : formatterTo2.format(Some value)
export const formatterTo2 = new Intl.NumberFormat('fr-FR', {
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
});

export const getParams = async () => {
  var param = null
  await fetch('/param.json'
    , {
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      }
    }
  )
    .then(async function (response) {
      param = await response.json();
      //localStorage.setItem('urlService', true);
      //localStorage.setItem('appID',response.data.jData.name);
    })
    .then(function (myJson) {
      //console.log(myJson);
    });
  return param
}

export function addDays(date, days) {
  const newDate = new Date(date);
  newDate.setDate(newDate.getDate() + days);
  return newDate;
}

export function getDates(startDate, stopDate) {
  var dateArray = []
  var currentDate = startDate;
  while (currentDate <= stopDate) {
    dateArray.push(currentDate)
    currentDate = currentDate.addDays(1);
  }
  return dateArray;
}

//add days between two days to an array 
export function getDates1(startDate, endDate) {
  let dates = [];
  let currentDate = new Date(startDate);
  while (currentDate <= endDate) {
    dates.push(new Date(currentDate));
    currentDate.setDate(currentDate.getDate() + 1);
  }
  return dates;
}

export const ConcatDate = (day) => {
  var dd = String(day.getDate()).padStart(2, '0');
  var mm = String(day.getMonth() + 1).padStart(2, '0');
  var today = mm + dd
  return today
}

export const couleur = () => {
  return '#' + ((1 << 24) * (Math.random() + 1) | 0).toString(16).substr(1)
}

export const couleurs = (val) => {
  var tab = []
  for (let pas = 0; pas < val; pas++) {
    var col = '#' + (Math.random() * 0xFFFFFF << 0).toString(16);
    if (col !== '#000000' && col !== '#FFFFFF') {
      tab.push(col)
    }
  }
  return tab
}

export const rgbToHex = (rgb) => {
  //console.log(rgb)
  var index = rgb.indexOf("rgb");
  if (index !== -1) {
    const rgbExcludeFirst = rgb.split('rgb(')[1];
    const rgbExcludeLast = rgbExcludeFirst.split(')')[0];
    const rgbValueArray = rgbExcludeLast.split(',');
    const first = Number(rgbValueArray[0]).toString(16)
    const second = Number(rgbValueArray[1]).toString(16)
    const third = Number(rgbValueArray[2]).toString(16)
    return '#' + first + second + third
  } else return rgb
};

export const ColorApp = (col) => {
  switch (col) {
    case 'iRahati': return '#4cb050'
    case 'Boutiqa': return '#9a2120'
    default: return '#482e1e'
  }
}

export function getDaysInMonth(year, month) {
  return new Date(year, month, 0).getDate();
}

export const DateDebMonth = (mois, annee) => {
  var today = new Date();
  return (annee !== '') ? new Date(annee, mois - 1, 1) : new Date(today.getFullYear(), mois - 1, 1);
}

export const DateFinMonth = (mois, annee) => {
  var today = new Date();
  return (annee !== '') ? new Date(annee, mois, 0) : new Date(today.getFullYear(), mois, 0);
}

const getTrimMonth = (trim) => {
  switch (trim) {
    case 1: return ['01', '03']
    case 2: return ['04', '06']
    case 3: return ['07', '09']
    default: return ['10', '12']
  }
}

export const TrimDebFin = (trim, annee) => {
  var result = []
  var array = getTrimMonth(trim);
  result.push(DateDebMonth(array[0], annee))
  result.push(DateFinMonth(array[array.length - 1], annee))
  return result;
}
export const AnnDebFin = (ann, date1, date2) => {
  var dd = String(date1.getDate()).padStart(2, '0');
  var mm = String(date1.getMonth() + 1).padStart(2, '0');
  var day = new Date(ann, mm - 1, dd)

  var dd1 = String(date2.getDate()).padStart(2, '0');
  var mm1 = String(date2.getMonth() + 1).padStart(2, '0');
  var day1 = new Date(ann, mm1 - 1, dd1)
  return [day, day1]
}
/*export const getyear=()=>{
 var today=new Date()
 console.log(today)
 var date =today.getFullYear()
 console.log(date)
 const array=[{id:1,name:(date).toString()},{id:2,name:(date-1).toString()},{id:3,name:(date-2).toString()},{id:4,name:(date-3).toString()},
              {id:5,name:(date-4).toString()}]
 console.log(array)
 return array;
}

export const getMonthYear=(ann)=>{
 console.log(ann)
 var array=[]
   var today=new Date()
   var monthNames = ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"];
  if(ann===1){
   var mm = String(today.getMonth() + 1).padStart(2, '0'); 
   console.log(mm,mm.substr(1)-1)
   console.log(monthNames.slice(0,mm.substr(1)-1))
   var m=monthNames.slice(0,mm.substr(1)-1)
   monthNames.map((el,index)=>{
     array.push({id:index+1,name:el})
   })
   console.log(array)
   return array
  }else{
   return [{id:1,name:"Janvier"},{id:2,name:" Février"},{id:3,name:"Mars"},{id:4,name:"Avril"},
           {id:5,name:"Mai"},{id:6,name:"Juin"},{id:7,name:"Juillet"},{id:8,name:"Août"},
           {id:9,name:"Septembre"},{id:10,name:"Octobre"},{id:11,name:"Novembre"},{id:12,name:"Décembre"}];
  }
}

export const getTrimYear=()=>{
 var today=new Date()
 console.log(today)
 var date =today.getFullYear()
 console.log(date)
 const array=[{id:1,name:(date).toString()},{id:2,name:(date-1).toString()},{id:3,name:(date-2).toString()},{id:4,name:(date-3).toString()},
              {id:5,name:(date-4).toString()}]
 console.log(array)
 return array;
}*/

export function getYear(date) {
  var yyyy = date.getFullYear();
  return yyyy.toString();
}

export function MonthName(num) {
  switch (num) {
    case '01': return 'Janvier';
    case '02': return 'Fevrier';
    case '03': return 'Mars';
    case '04': return 'Avril';
    case '05': return 'Mai';
    case '06': return 'Juin';
    case '07': return 'Juillet';
    case '08': return 'Aout';
    case '09': return 'Septembre';
    case '10': return 'Octobre';
    case '11': return 'Novembre';
    default: return 'Decembre';
  }
}
export function MonthName1(num) {
  switch (num) {
    case 'Janvier': return '01';
    case 'Fevrier': return '02';
    case 'Mars': return '03';
    case 'Avril': return '04';
    case 'Mai': return '05';
    case 'Juin': return '06';
    case 'Juillet': return '07';
    case 'Aout': return '08';
    case 'Septembre': return '09';
    case 'Octobre': return '10';
    case 'Novembre': return '11';
    default: return '12';
  }
}
export function getMonth(date) {
  var mm = String(date.getMonth() + 1).padStart(2, '0');
  var monthName = MonthName(mm)
  return monthName;
}

export function include(arr, obj) {
  if (arr.length === 0) {
    return false
  } else {
    for (var i = 0; i < arr.length; i++) {
      if (arr[i] === obj) {
        return true
      }
    }
    return false
  }

}
export function isHex(str) {
  var regex = /[0-9A-Fa-f]{6}/g;
  if (str.match(regex)) {
    return true
  } else {
    return false
  }
}
export function isNumeric(str) {
  if (typeof str != "string") return false // we only process strings!  
  return !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
    !isNaN(parseFloat(str)) // ...and ensure strings of whitespace fail
}
//Vérifie l'égalité de deux tableau
export function isEqual(array1, array2) {
  let isEqual = true;
  if (array1.length !== array2.length) {
    isEqual = false;
  } else {
    for (let i = 0; i < array1.length; i++) {
      if (array1[i] !== array2[i]) {
        isEqual = false;
        break;
      }
    }
  }
  return isEqual
}
//fonction pour detecter l'element manquant d'un tableau par rapport un autre
export function MissingElem(array1, array2) {
  const missElem = array2.find(element => !array1.includes(element));
  return missElem

}
//fonction pour detecter tous les elements manquant d'un tableau par rapport un autre
export function MissingElems(array1, array2) {
  const missElem = array2.filter(element => !array1.includes(element));
  return missElem

}
//fonction pour detecter tous les elements manquant d'un tableau d'objets par rapport un autre tableau simple 
export function MissingObjs(array1, array2, att) {
  const missObjs = array2.filter(obj2 => !array1.some(obj1 => obj2 === obj1[att])
  );
  return missObjs
}


export function sortTable(data, att) {
  const sortedData = data.sort((a, b) => {
    if (a[att] < b[att]) {
      return -1;
    } else if (a[att] > b[att]) {
      return 1;
    }
    return 0;
  });
  return sortedData
}
export function trouverOccurrencesParCle(tableau, cle, valeurRecherchee) {
  return tableau.filter(element => element[cle] === valeurRecherchee);
}

export const fetchParam = async () => {
  const response = await axiosGetAction("_prm.php", "gets");
  if (response.data.err && response.data.err !== "-1") {
    return response.data.err;
  } else {
    axiosResponse(response, () => {
      localStorage.setItem(
        "defaultParams",
        JSON.stringify(response.data.jData)
      );
      extParams = response.data.jData
    });
    return response.data.jData;
  }
};

export function hexToRgba(hex, alpha = 0.2) {
  let r = 0, g = 0, b = 0;

  // Remove the `#` if it's there
  hex = hex.replace('#', '');

  if (hex.length === 3) {
    r = parseInt(hex[0] + hex[0], 16);
    g = parseInt(hex[1] + hex[1], 16);
    b = parseInt(hex[2] + hex[2], 16);
  } else if (hex.length === 6) {
    r = parseInt(hex.substring(0, 2), 16);
    g = parseInt(hex.substring(2, 4), 16);
    b = parseInt(hex.substring(4, 6), 16);
  }

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
}

// validate GPS format
export const isValidGPS = (value) => {
  const regex = /^\(\s*-?\d{1,2}\.\d{1,6}\s*,\s*-?\d{1,3}\.\d{1,6}\s*\)$/;
  return regex.test(value);
};


export const formatDateTime = (dateString) => {
  if (!dateString) return '';

  const date = new Date(dateString.replace(' ', 'T'));
  if (isNaN(date.getTime())) return '';

  return date.toLocaleString('fr-FR', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

export const formatDateForAPI = (date) => {
  // console.log('before',date)
  if (!date) return null;
  // if (typeof date === 'string') return date;
  // console.log('after',date)

  const validDate = new Date(date);
  if (isNaN(validDate.getTime())) {
    console.error('Date invalide:', date);
    return null;
  }

  const day = String(validDate.getDate()).padStart(2, '0');
  const month = String(validDate.getMonth() + 1).padStart(2, '0');
  const year = validDate.getFullYear();

  // console.log(`${day}-${month}-${year}`)

  return `${day}-${month}-${year}`;
};

export const formatDateForAPI2 = (date) => {
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
};

export const compareDates = (date) => {
  if (!date) return null;

  // Convertit "dd-MM-yyyy" en Date JavaScript
  const parts = date.split('-');
  if (parts.length !== 3) return null;
  const formatedDate = new Date(`${parts[2]}-${parts[1]}-${parts[0]}`);

  // Today en format comparable
  const today = new Date(getDate2());

  if (isNaN(formatedDate.getTime()) || isNaN(today.getTime())) {
    return null;
  }

  const diffTime = formatedDate - today;
  // console.log(diffTime / (1000 * 60 * 60 * 24))
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
};


export const convertStringIDToNumber = (ID) => {
  if (typeof ID === 'string') {
    // Récupère uniquement les chiffres et les convertit en entier
    const numericPart = ID.replace(/\D/g, '');
    ID = numericPart ? parseInt(numericPart, 10) : ID;
  }
  return ID
};

//contact validation 
export const validateAndSetContact = (value, setterFunction) => {
  const digitsOnly = value.replace(/\D/g, '');
  if (digitsOnly.length <= 10) {
    setterFunction(digitsOnly);
  } else {
    setterFunction(digitsOnly.slice(0, 10));
  }
};
export const validatePhone = (phone, required = true) => {

  if (!phone) {
    return {
      isValid: !required,
      message: required ? 'Le numéro de téléphone est obligatoire' : ''
    };
  }

  const regex = /^0[5-7]\d{8}$/;

  const isValid = regex.test(phone);

  return {
    isValid,
    message: isValid ? '' : 'Le numéro de téléphone doit contenir 10 chiffres valides'
  };
};
export const validateEmail = (email) => {
  if (!email) {
    return {
      isValid: false,
      message: "L'email est obligatoire"
    };
  }

  const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  const isValid = regex.test(email);

  return {
    isValid,
    message: isValid ? '' : "Format d'email invalide"
  };
};
// Validation simple du CIN (9 chiffres)
export const validateCIN = (cin) => {
  if (!cin) return { isValid: true, message: '' };

  const cinRegex = /^\d{9}$/;
  return {
    isValid: cinRegex.test(cin),
    message: cinRegex.test(cin) ? '' : 'Le CIN doit contenir 9 chiffres'
  };
};

// Validation simple du NIN (18 chiffres)
export const validateNIN = (nin) => {
  if (!nin) {
    return {
      isValid: false,
      message: 'Le NIN est obligatoire'
    };
  }

  if (nin.length < 18) {
    return {
      isValid: false,
      message: 'Le NIN doit contenir 18 chiffres'
    };
  }

  return {
    isValid: true,
    message: ''
  };
};
export const validateNIF = (nif) => {
  if (!nif) {
    return {
      isValid: false,
      message: "Le NIF est obligatoire"
    };
  }

  if (nif.length !== 15) {
    return {
      isValid: false,
      message: "Le NIF doit contenir 15 chiffres"
    };
  }

  return {
    isValid: true,
    message: ""
  };
};
// Validation simple du NSS (13 chiffres)
export const validateNSS = (nss) => {
  if (!nss) return { isValid: true, message: '' };

  const nssRegex = /^\d{13}$/;
  return {
    isValid: nssRegex.test(nss),
    message: nssRegex.test(nss) ? '' : 'Le NSS doit contenir 13 chiffres'
  };
};

// Validation simple du numero d'acte de naissance (5 chiffres)
export const validateBirthActnum = (birthActnum) => {
  if (!birthActnum) return { isValid: true, message: '' };

  const birthActnumRegex = /^\d{5}$/;
  return {
    isValid: birthActnumRegex.test(birthActnum),
    message: birthActnumRegex.test(birthActnum) ? '' : "Le Numero d'acte de naissance doit contenir 5 chiffres"
  };
};

export const formatPlateNumber = (plateNumber) => {
  if (!plateNumber) return '';

  const cleaned = plateNumber.replace(/[\s\-\.]/g, '').trim();

  if (cleaned.length === 10) {
    return `${cleaned.substring(0, 5)} ${cleaned.substring(5, 8)}-${cleaned.substring(8, 10)}`;
  } else if (cleaned.length === 11) {
    return `${cleaned.substring(0, 6)} ${cleaned.substring(6, 9)}-${cleaned.substring(9, 11)}`;
  }

  return plateNumber;
};

// Validation de la plaque d'immatriculation
// export const validatePlateNumber = (plateNumber) => {
//   if (!plateNumber) return { isValid: true, message: '' };

//   // Nettoyage: enlever les espaces, tirets, points
//   const cleanedPlate = plateNumber.replace(/[\s\-\.]/g, '').trim();

//   // Validation basique: 10-11 chiffres
//   if (!/^\d{10,11}$/.test(cleanedPlate)) {
//     return {
//       isValid: false,
//       message: 'La plaque doit contenir 10 ou 11 chiffres'
//     };
//   }

//   // Séparation des groupes
//   let group1, group2, group3;

//   if (cleanedPlate.length === 10) {
//     // Format standard: 5-3-2
//     group1 = cleanedPlate.substring(0, 5);
//     group2 = cleanedPlate.substring(5, 8);
//     group3 = cleanedPlate.substring(8, 10);
//   } else {
//     // Format Alger: 6-3-2
//     group1 = cleanedPlate.substring(0, 6);
//     group2 = cleanedPlate.substring(6, 9);
//     group3 = cleanedPlate.substring(9, 11);
//   }

//   // Validation Groupe 1: Numéro de dossier
//   if (group3 === '16') {
//     // Wilaya d'Alger: groupe 1 doit avoir 6 chiffres
//     if (group1.length !== 6) {
//       return {
//         isValid: false,
//         message: 'Pour la wilaya d\'Alger (16), le numéro de dossier doit avoir 6 chiffres'
//       };
//     }
//   } else {
//     // Autres wilayas: groupe 1 doit avoir 5 chiffres
//     if (group1.length !== 5) {
//       return {
//         isValid: false,
//         message: 'Le numéro de dossier doit avoir 5 chiffres (6 pour Alger)'
//       };
//     }
//   }

//   // Validation Groupe 2: Type de véhicule + année
//   const vehicleType = parseInt(group2.charAt(0));
//   const yearDigits = parseInt(group2.substring(1, 3));
//   const currentYear = new Date().getFullYear();
//   const currentYearLastTwo = currentYear % 100;

//   // Validation du type de véhicule
//   if (vehicleType < 1 || vehicleType > 9) {
//     return {
//       isValid: false,
//       message: 'Le type de véhicule doit être entre 1 et 9'
//     };
//   }

//   // Validation de l'année (derniers 2 chiffres)
//   if (yearDigits < 0 || yearDigits > currentYearLastTwo) {
//     // Note: On pourrait accepter jusqu'à l'année en cours + 1 pour les véhicules neufs
//     const maxYear = Math.min(currentYearLastTwo + 1, 99);
//     return {
//       isValid: false,
//       message: `L'année doit être entre 00 et ${maxYear.toString().padStart(2, '0')}`
//     };
//   }

//   // Validation Groupe 3: Code wilaya
//   const wilayaCode = parseInt(group3);
//   if (wilayaCode < 1 || wilayaCode > 58) {
//     return {
//       isValid: false,
//       message: 'Le code wilaya doit être entre 01 et 58'
//     };
//   }

//   // Validation supplémentaire: cohérence entre longueur groupe 1 et code wilaya
//   if (wilayaCode === 16 && group1.length !== 6) {
//     return {
//       isValid: false,
//       message: 'Pour Alger (16), le numéro de dossier doit avoir 6 chiffres'
//     };
//   }
//   if (wilayaCode !== 16 && group1.length !== 5) {
//     return {
//       isValid: false,
//       message: 'Pour les wilayas autres qu\'Alger, le numéro de dossier doit avoir 5 chiffres'
//     };
//   }

//   // Tous les tests passés
//   return {
//     isValid: true,
//     message: '',
//     formatted: formatPlateNumber(cleanedPlate)
//   };
// };

export const formatCurrency = (value) => {
  if (!value && value !== 0) return "-";
  return new Intl.NumberFormat("fr-FR").format(value) + " DA";
};

export const formatDaysToReadable = (days) => {
  if (days === null || days === undefined) return null;

  // Si plus de 365 jours (1 an)
  if (days >= 365) {
    const years = Math.floor(days / 365);
    const remainingDays = days % 365;
    if (remainingDays === 0) {
      return `${years} an${years > 1 ? 's' : ''}`;
    } else {
      const months = Math.floor(remainingDays / 30);
      if (months === 0) {
        return `${years} an${years > 1 ? 's' : ''} et ${remainingDays} jour${remainingDays > 1 ? 's' : ''}`;
      } else {
        return `${years} an${years > 1 ? 's' : ''} et ${months} mois`;
      }
    }
  }

  // Si plus de 30 jours (1 mois)
  if (days >= 30) {
    const months = Math.floor(days / 30);
    const remainingDays = days % 30;
    if (remainingDays === 0) {
      return `${months} mois`;
    } else {
      return `${months} mois et ${remainingDays} jour${remainingDays > 1 ? 's' : ''}`;
    }
  }

  // Moins de 30 jours
  return `${days} jour${days > 1 ? 's' : ''}`;
};

export const validateAndSetMaterialType = (value, setterFunction) => {
  if (value.length <= 3) {
    setterFunction(value);
  } else {
    setterFunction(value.slice(0, 3));
  }
};

// calendar functions 
export const getStartOfWeek = (date) => {
  const d = new Date(date);
  const day = d.getDay();
  const diff = d.getDate() - day;
  return new Date(d.setDate(diff));
};

export const formatPhoneDisplay = (phone) => {
  if (!phone) return "";

  let digits = String(phone).replace(/\D/g, "");
  if (digits.length === 10) {
    return digits.replace(/(\d{2})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
  }
  if (digits.startsWith("213")) {
    digits = digits.slice(3);
    return "+213 " + digits.replace(/(\d{1})(\d{2})(\d{2})(\d{2})(\d{2})/, "$1 $2 $3 $4 $5");
  }
  return phone;
};

export function formatDaysToYMD(days) {
  if (!Number.isFinite(days)) return "—";

  const years = Math.floor(days / 365);
  const months = Math.floor((days % 365) / 30);
  const remainingDays = (days % 365) % 30;

  const parts = [];
  if (years > 0) parts.push(`${years} an${years > 1 ? "s" : ""}`);
  if (months > 0) parts.push(`${months} mois`);
  if (remainingDays > 0) parts.push(`${remainingDays} jour${remainingDays > 1 ? "s" : ""}`);

  return parts.length > 0 ? parts.join(", ") : "0 jour";
}

export const getLocalDateString = (date) => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// Output: "2026-03-19   input jeudi 19 mars 2026"
export const formatDateToHumanReadable = (dateStr) => {
  if (!dateStr) return '';
  const [year, month, day] = dateStr.split('-').map(Number);
  const d = new Date(year, month - 1, day);
  return d.toLocaleDateString('fr-FR', {
    weekday: 'long',
    day: 'numeric',
    month: 'long',
    year: 'numeric',
  });
  // fonction general pour obtenir le style de badge en fonction du status
};

export const getStatusStyle = (color) => {
  const colorName = color || 'gray';

  return {
    color: `var(--badge-text-${colorName})`,
    backgroundColor: `var(--badge-background-${colorName})`,
    borderColor: `var(--badge-border-${colorName})`,
  };
};

export const monthOptions = [
  { id: "01", name: "Janvier" },
  { id: "02", name: "Février" },
  { id: "03", name: "Mars" },
  { id: "04", name: "Avril" },
  { id: "05", name: "Mai" },
  { id: "06", name: "Juin" },
  { id: "07", name: "Juillet" },
  { id: "08", name: "Août" },
  { id: "09", name: "Septembre" },
  { id: "10", name: "Octobre" },
  { id: "11", name: "Novembre" },
  { id: "12", name: "Décembre" },
];

export const parseLeaveDate = (str) => {
  if (!str) return null;
  const [d, m, y] = str.split("-");
  return new Date(+y, +m - 1, +d);
};

//  convert "HH:MM" to minutes  
export const toMinutes = (timeStr) => {
  if (!timeStr) return null;
  const [h, m] = timeStr.split(':').map(Number);
  return h * 60 + m;
}

// Fonction de formatage pour plaque d'immatriculation
export const formatLicensePlate = (value) => {
  let cleaned = value.replace(/\D/g, '');

  // Limite à 11 chiffres (6+3+2)
  cleaned = cleaned.slice(0, 11);

  // Formatage: 6 chiffres + espace + 3 chiffres + espace + 2 chiffres
  let formatted = '';
  for (let i = 0; i < cleaned.length; i++) {
    if (i === 6 || i === 9) {
      formatted += ' ';
    }
    formatted += cleaned[i];
  }

  return formatted;
};

// Fonction de formatage pour carte grise : xxxxxxx/xx/xx
export const formatRegistrationCard = (value) => {
  let cleaned = value.replace(/\D/g, '');

  // Limite à 11 chiffres (7+2+2)
  cleaned = cleaned.slice(0, 11);

  // Formatage: 7 chiffres + slash + 2 chiffres + slash + 2 chiffres
  if (cleaned.length <= 7) {
    return cleaned;
  } else if (cleaned.length <= 9) {
    return `${cleaned.slice(0, 7)}/${cleaned.slice(7)}`;
  } else {
    return `${cleaned.slice(0, 7)}/${cleaned.slice(7, 9)}/${cleaned.slice(9, 11)}`;
  }
};

export const formatDateOnly = (dateString) => {
  if (!dateString) return '';

  // Si la date est au format "12-04-2026 00:00"
  const datePart = dateString.split(' ')[0];
  return datePart;
};

export const validatePlateNumber = (plate, fieldName) => {
  if (!plate) return true;

  const cleanedPlate = plate.replace(/\s|\//g, '');
  
  // Vérifier que la longueur est entre 10 et 11 caractères (sans espaces)
  if (cleanedPlate.length !== 11) {
    return {
      isValid: false,
      message: `${fieldName} doit contenir 11 chiffres`
    };
  }
  return {
    isValid: true,
    message: ''
  };
};
export const formatMinutes = (mins) => {
	const h = Math.floor(mins / 60);
	const m = mins % 60;

	if (m === 0) {
		return `${h}h`;
	}

	return `${h}h${m.toString().padStart(2, "0")}`;
};

export function axiosResponseV2(
  response,
  showAlert,
  onSuccess = () => {},
  setData = () => {},
  options = {},
) {
  const {
    showSuccess = true,
    showError = true,
    customMessages = {},
  } = options;

  try {
    if (!response?.data) {
      if (showError)
        showAlert(
          customMessages.error || "Réponse invalide du serveur.",
          "error",
        );
      return;
    }

    const { success, message, data } = response.data;

    if (success) {
      const msg = customMessages.success ?? message;
      if (msg && showSuccess) showAlert(msg, "success");
      setData(data);
      onSuccess(data, setData);
    } else {
      setData(null);
      const msg = customMessages.error ?? message;
      if (msg && showError) showAlert(msg, "error");

      if (
        message?.toLowerCase().includes("-1") ||
        message?.includes("expiré")
      ) {
        localStorage.clear();
        window.location = "/";
      }
    }
  } catch (err) {
    console.error("Erreur dans axiosResponseV2:", err);
    if (showError)
      showAlert(
        customMessages.error ||
          "Erreur interne lors du traitement de la réponse.",
        "error",
      );
  }
}